import { Box, Button, Link, Paper, Stack, Typography } from '@mui/material';
import { getAccountTabRoute } from 'features/account/account-management/account-management-tabs';
import { AccountManagementTabs } from 'features/account/account-management/account-management.types';
import NotificationList from 'features/engagement/notifications/notification-list';
import { useNotificationActions, useNotificationList } from 'features/engagement/notifications/use-notifications';
import { QueryState } from 'features/engagement/shared/ui';
import { useUserData } from 'hooks/use-user-data';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { Link as RouterLink, useNavigate } from 'react-router';

/** /notifications — all Mitteilungen of the signed-in user. */
const NotificationsPage: React.FC = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { token } = useUserData();
  const list = useNotificationList(token, 100);
  const { read, readAll, openCta } = useNotificationActions();
  const items = list.data?.items ?? [];
  const unread = list.data?.unread ?? 0;

  return (
    <Box sx={{ p: { xs: '20px 16px 24px', lg: '32px 48px 48px' }, maxWidth: 820 }}>
      <Stack direction={'row'} alignItems={'center'} justifyContent={'space-between'} sx={{ mb: 2 }} gap={2}>
        <Box>
          <Typography sx={{ fontSize: 26, fontWeight: 500 }}>{t('engNotifTitle')}</Typography>
          <Typography sx={{ fontSize: 14, color: 'text.secondary' }}>{t('engNotifPageSubtitle')}</Typography>
        </Box>
        <Button variant={'outlined'} sx={{ textTransform: 'none' }} disabled={unread === 0 || readAll.isPending} onClick={() => readAll.mutate()}>
          {t('engNotifReadAll')}
        </Button>
      </Stack>
      <Paper variant={'outlined'} sx={{ borderRadius: 2, overflow: 'hidden' }}>
        <QueryState isLoading={list.isLoading} error={list.error} isEmpty={items.length === 0} emptyText={t('engNotifEmpty')}>
          <NotificationList items={items} onMarkRead={(n) => read.mutate(n._id)} onOpenCta={(n) => openCta(n, navigate)} />
        </QueryState>
      </Paper>
      <Typography sx={{ fontSize: 13, color: 'text.secondary', mt: 2 }}>
        <Link component={RouterLink} to={getAccountTabRoute(AccountManagementTabs.NOTIFICATIONS)}>
          {t('engNotifSettingsLink')}
        </Link>
      </Typography>
    </Box>
  );
};

export default NotificationsPage;
